import { render, staticRenderFns } from "./BasePhoneNumberInputComponent.html?vue&type=template&id=d85a8b8c&scoped=true&"
import script from "./BasePhoneNumberInputComponent.js?vue&type=script&lang=js&"
export * from "./BasePhoneNumberInputComponent.js?vue&type=script&lang=js&"
import style0 from "./BasePhoneNumberInputComponent.scss?vue&type=style&index=0&id=d85a8b8c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85a8b8c",
  null
  
)

export default component.exports